import { render, staticRenderFns } from "./payroll-batch-reports.vue?vue&type=template&id=760a116b&"
import script from "./payroll-batch-reports.vue?vue&type=script&lang=js&"
export * from "./payroll-batch-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports